
import FaqWeb from "./FaqWeb"
import FaqMob from "./FaqMob"
import { useMediaQuery } from "@mui/material"
export default function Faq() {
    const isSmallScreen = useMediaQuery("(max-width:800px)")
    return <>{isSmallScreen ? <FaqMob /> : <FaqWeb />} </>
 }